export type UpdateProgrammePayload = {
  merchantCode: string;
  programmeCode: string;

  name?: string;
  preferredBasketCode?: string | null;
};

//

export type GetProgrammesQuery = {
  merchantCode: string;
};

export type GetProgrammesResponse = {
  content: Programme[];
  totalElements: number;
  totalPages: number;
};

//

export type CreateProgrammePayload = {
  merchantCode: string;

  name: string;
  type: string; // always "MANAGED" for the "CREATE_MANAGED_PROGRAMME" feature
  activityType: string; // always "EVENT" for now

  preferredBasketCode?: any
};

//
//

export type Programme = {
  type: ProgrammeType;
  code: string;
  useAsDefault: boolean;
  createdAt: Date;
  name?: string;
  subtitle?: string;
  activityType: ProgrammeActivityType;
  preferredBasketCode: string | null;
  quotePriceDisplayMode?: string | null;
  serviceFee?: number;
  status: string;
  transactionPriceDisplayMode: TransactionPriceDisplayMode;
};

export enum ProgrammeType {
  MANAGED = 'MANAGED',
  CUSTOMER = 'CUSTOMER',
  MYCARBONCLICK = 'MYCARBONCLICK',
}

export enum ProgrammeActivityType {
  FLIGHT = 'FLIGHT',
  JOURNEY = 'JOURNEY',
  EMPLOYEE = 'EMPLOYEE',
  EVENT = 'EVENT',
  BUSINESS = 'BUSINESS',
  // CORPORATE_FLIGHT = 'CORPORATE_FLIGHT',
  NONE = 'NONE',
}

export enum TransactionPriceDisplayMode {
  HIDE_SERVICE_FEE = 'HIDE_SERVICE_FEE',
  HIDE_ALL = 'HIDE_ALL',
  // other
}

export enum ProgrammeStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
